module.exports = __webpack_public_path__ + "img/sec.d0289dc0.png";